import {
  useGetMasterDistrict,
  useGetMasterProvince,
  useGetTransportType,
  useMasterTransport,
} from "hooks/useMasterData";
import {
  Button,
  Form,
  FormInstance,
  Input,
  Modal,
  Select,
  TimePicker,
  Typography,
  message,
} from "antd";
import React, { useEffect, useState } from "react";
import {
  BoxlistRes,
  DeliveryPointData,
  GetOrderDetailData,
  MasterTransport,
  Transportbuslist,
} from "services/interface";
import { useConfirmOrderTransport } from "hooks/useOrders";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import ModalTransport from "./ModalTransport";
import { useAppSelector } from "store";
import {
  useCreateParking,
  useDeliveryPoint,
  useGetParkingList,
} from "hooks/useShipping";
import DescriptionForm from "components/ManageTransportaition/ModalCreateDeliveryPoint/DescriptionForm";
import styled from "@emotion/styled";
import { PlusOutlined } from "@ant-design/icons";
import { timeEnd } from "console";

dayjs.extend(customParseFormat);

interface UpdateTransportLocalProps {
  formTransport: FormInstance<any>;
  item: GetOrderDetailData;
  refetchData: () => void;
  refectShipped?: () => void;
  statusPage: string;
  onClose: () => void;
  memo: string;
}

const { Option } = Select;

const UpdateTransportLocal = ({
  formTransport,
  item,
  refetchData,
  refectShipped,
  statusPage,
  onClose,
  memo,
}: UpdateTransportLocalProps) => {
  const factoryId = useAppSelector(
    (state) => state.auth.profile?.user?.role?.ref_id
  );

  const [masterTransport, setMasterTransport] = useState<MasterTransport[]>([]);
  const [selectTransport, setSelectTransport] = useState<MasterTransport>();

  const [provinceIdAddress, setProvinceIdAddress] = useState<number>(0);
  const [districtIdAddress, setDistrictIdAddress] = useState<number>(0);

  const [provinceIdstart, setProvinceIdstart] = useState<number>(0);
  const [provinceIdend, setProvinceIdend] = useState<number>(0);

  const [formConfigs] = Form.useForm();
  const [formModal] = Form.useForm();

  const [showParking, setShowParking] = useState<boolean>(false);

  const { mutate: CreateParking } = useCreateParking();
  const { mutate: confirmTransport } = useConfirmOrderTransport();
  const { mutate: getDeliveryPoint } = useDeliveryPoint();
  const { data: masterTransportType } = useGetTransportType();

  const [boxListUniq, setBoxListUniq] = useState<BoxlistRes[]>([]);



  const [search, setSearch] = useState<string>("");

  const { data, isLoading, refetch } = useMasterTransport({
    search: search,
  });

  const { data: masterProviceData } = useGetMasterProvince();

  const { data: masterDistrictDataStart } =
    useGetMasterDistrict(provinceIdstart);

  const { data: masterDistrictDataAddress } =
    useGetMasterDistrict(provinceIdAddress);

  const { data: masterDistrictDataEnd } = useGetMasterDistrict(provinceIdend);

  useEffect(() => {
    if (data) {
      setMasterTransport(data.data.master_data);
    }
  }, [data]);

  useEffect(() => {
    formTransport.resetFields();
  }, [formTransport]);

  const [childrenParking, setChildrenParking] = useState<React.ReactNode[]>([]);

  const { mutate: ParkingById } = useGetParkingList();

  const onCloseModal = () => {
    formModal.resetFields();
    setShowParking(false);
  };

  const getParkingList = (typeId: string) => {
    ParkingById(typeId, {
      onSuccess: (res) => {
        if (res.status === "success") {
          const newChildrenTransport = res.data.map((item: any) => (
            <Option key={item.id} value={item.id}>
              {item.delivery_point}
            </Option>
          ));
          setChildrenParking(newChildrenTransport);
        } else {
          // message.error(`ลบไม่สำเร็จ: ${res.error_message}`);
        }
      },
      onError: (error) => {
        // message.error(`ลบไม่สำเร็จ: ${error.message}`);
      },
    });
  };

  const childrenTransport: React.ReactNode[] = [];
  masterTransport?.map((item) => {
    return childrenTransport.push(
      <Option key={item.id} value={item.id}>
        <div style={{ display: "flex" }}>
          <div style={{ flex: 2 }}>
            {`${item.name}  ${item.province_name_start} - ${item.province_name_end}
         (รอบ ${item.time_start} - ${item.time_end} น.)`}
          </div>

          {/* <div>
            <Button
              type="primary"
              size="small"
              onClick={() => {
                
              }}
            >
              ลบ
            </Button>
          </div> */}
        </div>
      </Option>
    );
  });

  const childrenTransportType: React.ReactNode[] = [];
  masterTransportType?.map((item) => {
    return childrenTransportType.push(
      <Option key={item.key} value={item.key}>
        {item.name}
      </Option>
    );
  });

  const childrenProviceStart: React.ReactNode[] = [];
  masterProviceData?.map((item) => {
    return childrenProviceStart.push(
      <Option key={item.id} value={item.id}>
        {item.name_th}
      </Option>
    );
  });

  const childrenProviceAddress: React.ReactNode[] = [];
  masterDistrictDataAddress?.map((item) => {
    return childrenProviceAddress.push(
      <Option key={item.id} value={item.id}>
        {item.name_th}
      </Option>
    );
  });

  const childrenProviceEnd: React.ReactNode[] = [];
  masterProviceData?.map((item) => {
    return childrenProviceEnd.push(
      <Option key={item.id} value={item.id}>
        {item.name_th}
      </Option>
    );
  });

  const filterOption = (input: string, option: any) =>
    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;

  useEffect(() => {
    if (selectTransport) {
      setProvinceIdstart(selectTransport.province_start_id);
      setProvinceIdend(selectTransport.province_end_id);

      formTransport.setFieldsValue({
        transport_name: selectTransport.name,
        province_start_id: selectTransport.province_start_id,
        district_start_id: selectTransport.district_start_id,
        province_end_id: selectTransport.province_end_id,
        district_end_id: selectTransport.district_end_id,
        station_start: selectTransport.station_start,
        station_end: selectTransport.station_end,
        type: selectTransport.type,
        license_plate: selectTransport.license_plate,
        car_no: selectTransport.car_no,
        timeStart: selectTransport.time_start
          ? dayjs(selectTransport.time_start, "HH:mm")
          : null,
        timeEnd: selectTransport.time_end
          ? dayjs(selectTransport.time_end, "HH:mm")
          : null,
      });
    }
  }, [formTransport, selectTransport]);

  useEffect(() => {
    if (item.history_transport) {
      setProvinceIdstart(item.history_transport?.province_start_id);
      setProvinceIdend(item.history_transport?.province_end_id);

      formTransport.setFieldsValue({
        // transport_id: item.history_transport?.config_id;
        // transport_id: item.history_transport?.master_transport_id,
        transport_name: item.history_transport?.transport_name,
        province_start_id: item.history_transport?.province_start_id,
        district_start_id: item.history_transport?.district_start_id,
        province_end_id: item.history_transport?.province_end_id,
        district_end_id: item.history_transport?.district_end_id,
        remark: item.address_remark ?? "",
        station_start: item.history_transport?.station_start,
        station_end: item.history_transport?.station_end,
        type: item.history_transport?.history_transport_type,
        license_plate: item.history_transport?.license_plate,
        car_no: item.history_transport?.car_no,
        timeStart: item.history_transport.start_time
          ? dayjs(item.history_transport.start_time, "HH:mm")
          : null,
        timeEnd: item.history_transport.end_time
          ? dayjs(item.history_transport.end_time, "HH:mm")
          : null,
      });
      getParkingList(item.history_transport.master_transport_id);

      const boxListUniq = item.history_transport.box_list.reduce(
        (acc: BoxlistRes[], item) => {
          const found = acc.find((el) => el.name === item.name);
          if (!found) {
            acc.push(item);
          }
          return acc;
        },
        []
      );

      setBoxListUniq(boxListUniq);
    }

    getDeliveryPoint(
      {
        district_id: item.district_id ?? "",
        province_id: item.province_id,
       // factory_id: factoryId || "",
      },
      {
        onSuccess: (res) => {
          if (res.status === "success") {
            // message.success("สร้างสำเร็จ");
            console.log(res);
            const newChildrenTransport = res.data.data.map(
              (item: DeliveryPointData) => (
                <Option key={item.id} value={item.id}>
                  {item.delivery_point}
                </Option>
              )
            );
            setChildrenParking(newChildrenTransport);
          } else {
            message.error(`สร้างไม่สำเร็จ: ${res.error_message}`);
          }
        },
        onError: (error) => {
          message.error(`สร้างไม่สำเร็จ: ${error.message}`);
        },
      }
    );

    formTransport.setFieldsValue({
      district_address_id: item.district_id,
      province_address_id: item.province_id,
      parking_id: item.parking_id,
      remark: item.address_remark ?? "",
      transport_id: item.history_transport?.master_transport_id,
    //  timeEnd: item.history_transport?.end_time
    });

    setProvinceIdAddress(item.province_id);
    setDistrictIdAddress(item.district_id);
  }, [formTransport, item]);

  useEffect(() => {
    getDeliveryPoint(
      {
        district_id: districtIdAddress,
        province_id: provinceIdAddress,
       // factory_id: factoryId || "",
      },
      {
        onSuccess: (res) => {
          if (res.status === "success") {
            //message.success("สร้างสำเร็จ");
            const newChildrenTransport = res.data.data.map(
              (item: DeliveryPointData) => (
                <Option key={item.id} value={item.id}>
                  {item.delivery_point}
                </Option>
              )
            );
            setChildrenParking(newChildrenTransport);
          } else {
            message.error(`สร้างไม่สำเร็จ: ${res.error_message}`);
          }
        },
        onError: (error) => {
          message.error(`สร้างไม่สำเร็จ: ${error.message}`);
        },
      }
    );
  }, [districtIdAddress, getDeliveryPoint, provinceIdAddress]);

  const handelFinish = (value: any) => {
    const retail_order_item_id: string[] = [];
    item?.items.map((i) => {
      return i.keys.items.map((j) => {
        return retail_order_item_id.push(j);
      });
    });

    const transport_bus_list: Transportbuslist[] = [];
    retail_order_item_id.map((i, index) => {
      return transport_bus_list.push({
        master_transport_id: selectTransport?.id || masterTransport[0].id,
        order_id: item?.order_id,
        order_item_id: i,
        product_id: item?.items[index].product_id,
        station_start: value.station_start || "",
        province_start_id: value.province_start_id || 0,
        district_start_id: value.district_start_id || 0,
        station_end: value.station_end || "",
        province_end_id:
          value?.province_end_id || value?.province_address_id || 0,
        district_end_id:
          value?.district_end_id || value?.district_address_id || 0,
        time_start: dayjs(value?.timeStart).format("HH:mm") || "",
        time_end: dayjs(value?.timeEnd).format("HH:mm") || "",
        // service_price: item?.transport_price || 0,
        transport_type: value?.type || "",
        car_no: value?.car_no || "",
        license_plate: value?.license_plate || "",
        name: value?.transport_name || "",
        // description: value?.remark || "",
        parking_id: item?.history_transport.history_parking_id || "",
        remark:  "",
        order_box: item?.history_transport.order_box || 0,
        transport_box: item?.history_transport.transport_box || 0,
        remark_box: item?.history_transport.remark_box || "",
      });
    });

    confirmTransport(
      {
        factory_id: factoryId || "",
        remark: "",
        transport_bus_list: transport_bus_list,
        transport_postal_list: [],
        memo: memo,
      },
      {
        onSuccess: async () => {
          message.success("ยืนยันการส่งสำเร็จ");
          refetchData();
          refectShipped && refectShipped();
          onClose();
        },
        onError: (error) => {
          console.log(error);
        },
      }
    );
  };

  const onFinishModal = (values: any) => {
    CreateParking(
      {
        factory_id: factoryId || "",
        master_transport_id: selectTransport?.id || "",
        name: values.name,
      },
      {
        onSuccess: (res) => {
          if (res.status === "success") {
            message.success("สร้างสำเร็จ");
            getParkingList(selectTransport?.id || "");
            onCloseModal();
          } else {
            message.error(`สร้างไม่สำเร็จ: ${res.error_message}`);
          }
        },
        onError: (error) => {
          message.error(`สร้างไม่สำเร็จ: ${error.message}`);
        },
      }
    );
  };



  return (
    <div>
      <div style={{ marginBottom: 10 }}>
        <Typography.Text strong style={{}}>
          ข้อมูลจัดส่งจริง
        </Typography.Text>
        {/* <div style={{ display: "flex", flexDirection: "row" }}>
          <div style={{ flex: 3 }}>
            <Typography.Text style={{ fontWeight: "400" }}>
              จังหวัด
            </Typography.Text>
          </div>
          <div style={{ flex: 4 }}>
            <Typography.Text>{item.history_transport.history_province_name}</Typography.Text>
          </div>
        </div> */}
        {/* <div style={{ display: "flex", flexDirection: "row" }}>
          <div style={{ flex: 3 }}>
            <Typography.Text style={{ fontWeight: "400" }}>
              อำเภอ
            </Typography.Text>
          </div>
          <div style={{ flex: 4 }}>
            <Typography.Text>{item.history_transport.history_district_name}</Typography.Text>
          </div>
        </div> */}
        {/* <div style={{ display: "flex", flexDirection: "row" }}>
          <div style={{ flex: 3 }}>
            <Typography.Text style={{ fontWeight: "400" }}>
              จุดจอด
            </Typography.Text>
          </div>
          <div style={{ flex: 4 }}>
            <Typography.Text>
              {item.history_transport.history_parking_name}
            </Typography.Text>
          </div>
        </div> */}
        {/* <div style={{ display: "flex", flexDirection: "row" }}>
          <div style={{ flex: 3 }}>
            <Typography.Text style={{ fontWeight: "400" }}>
            ขนส่ง
            </Typography.Text>
          </div>
          <div style={{ flex: 4 }}>
            <Typography.Text>
              {item.history_transport.transport_name}
            </Typography.Text>
          </div>
        </div> */}
        {/* <div style={{ display: "flex", flexDirection: "row" }}>
          <div style={{ flex: 3 }}>
            <Typography.Text style={{ fontWeight: "400" }}>
            เวลาถึง
            </Typography.Text>
          </div>
          <div style={{ flex: 4 }}>
            <Typography.Text>
              {item.history_transport.end_time}
            </Typography.Text>
          </div>
        </div> */}
        {boxListUniq.map((item, index) => {
          return (
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div style={{ flex: 3 }}>
                <Typography.Text style={{ fontWeight: "400" }}>
                  {`จำนวนกล่อง ${item.name}`}
                </Typography.Text>
              </div>
              <div style={{ flex: 4 }}>
                <Typography.Text>{item.qty}</Typography.Text>
              </div>
            </div>
          );
        })}
        {/* <div style={{ display: "flex", flexDirection: "row" }}>
          <div style={{ flex: 3 }}>
            <Typography.Text style={{ fontWeight: "400" }}>
              จำนวนลังที่สั่ง
            </Typography.Text>
          </div>
          <div style={{ flex: 4 }}>
            <Typography.Text>
              {item.history_transport.order_box}
            </Typography.Text>
          </div>
        </div> */}
        {/* <div style={{ display: "flex", flexDirection: "row" }}>
          <div style={{ flex: 3 }}>
            <Typography.Text style={{ fontWeight: "400" }}>
              จำนวนลังที่รวมแล้วส่งจริง
            </Typography.Text>
          </div>
          <div style={{ flex: 4 }}>
            <Typography.Text>
              {item.history_transport.transport_box}
            </Typography.Text>
          </div>
        </div> */}
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div style={{ flex: 3 }}>
            <Typography.Text style={{ fontWeight: "400" }}>
              หมายเหตุจัดส่ง
            </Typography.Text>
          </div>
          <div style={{ flex: 4 }}>
            <Typography.Text>
              {item.history_transport_location.location_remark}
            </Typography.Text>
          </div>
        </div>
      </div>

      <Form form={formTransport} onFinish={handelFinish}>
        <div
          style={{
            marginBottom: 10,
            flexDirection: "row",
            alignItems: "center",
            paddingRight: 10,
            borderBottom: "1px solid #f0f0f0",
            paddingBottom: 10,
          }}
        ></div>
        {/* <Typography.Text strong style={{}}>
          ข้อมูลขนส่ง
        </Typography.Text>
        <Form.Item
          className="form-transport"
          name="transport_id"
          label="เลือกการจัดส่ง"
        >
          <Select
            loading={isLoading}
            showSearch
            placeholder="กรุณาเลือกการจัดส่ง"
            optionFilterProp="children"
            value={selectTransport?.id}
            onSelect={(value) => {
              setSelectTransport(
                masterTransport.find((item) => item.id === value)
              );
              getParkingList(value);
            }}
            onSearch={(value) => {
              setSearch(value);
            }}
            dropdownRender={(menu) => (
              <>
                {menu}
                <div style={{ marginTop: 10 }}>
                  <ModalTransport refetch={refetch} />
                </div>
              </>
            )}
          >
            {childrenTransport}
          </Select>
        </Form.Item> */}
        {/* <Form.Item
          label="ขนส่ง"
          name="transport_name"
          className="form-transport"
          // required
          // rules={[
          //   {
          //     required: true,
          //     message: "กรุณากรอกขนส่ง",
          //   },
          // ]}
        >
          <Input size="small" placeholder="กรุณากรอกขนส่ง" />
        </Form.Item>
        <Form.Item
          label="สถานีต้นทาง"
          name="station_start"
          className="form-transport"
          // required
          // rules={[
          //   {
          //     required: true,
          //     message: "กรุณากรอกสถานีต้นทาง",
          //   },
          // ]}
        >
          <Input size="small" placeholder="กรุณากรอกสถานีต้นทาง" />
        </Form.Item> */}
        {/* <Form.Item
          label="จังหวัดต้นทาง"
          className="form-transport"
          name="province_start_id"
          // required
          // rules={[
          //   {
          //     required: true,
          //     message: "กรุณาเลือกจังหวัดต้นทาง",
          //   },
          // ]}
        >
          <Select
            placeholder="เลือกจังหวัดต้นทาง"
            filterOption={filterOption}
            showSearch
            onSelect={(value) => {
              setProvinceIdstart(value);
              formTransport.setFieldsValue({
                district_start_id: undefined,
              });
            }}
          >
            {childrenProviceStart}
          </Select>
        </Form.Item> */}
        {/* <Form.Item
          label="อำเภอต้นทาง"
          className="form-transport"
          name="district_start_id"
          // required
          // rules={[
          //   {
          //     required: true,
          //     message: "กรุณาเลือกอำเภอต้นทาง",
          //   },
          // ]}
        >
          <Select
            placeholder="เลือกอำเภอต้นทาง"
            onSelect={(value) => {}}
            showSearch
            filterOption={filterOption}
          >
            {masterDistrictDataStart?.map((item) => (
              <Option key={item.id} value={item.id}>
                {item.name_th}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          label="สถานีปลายทาง"
          name="station_end"
          className="form-transport"
          // rules={[
          //   {
          //     required: true,
          //     message: "กรุณาเลือกสถานีปลายทาง",
          //   },
          // ]}
        >
          <Input size="small" placeholder="กรุณากรอกสถานีปลายทาง" />
        </Form.Item> */}
        {/* <Form.Item
          label="จังหวัดปลายทาง"
          className="form-transport"
          name="province_end_id"
          // required
          // rules={[
          //   {
          //     required: true,
          //     message: "กรุณาเลือกจังหวัดปลายทาง",
          //   },
          // ]}
        >
          <Select
            placeholder="เลือกจังหวัดปลายทาง"
            showSearch
            filterOption={filterOption}
            onSelect={(value) => {
              setProvinceIdend(value);
              formTransport.setFieldsValue({
                district_end_id: undefined,
              });
            }}
          >
            {childrenProviceEnd}
          </Select>
        </Form.Item> */}
        {/* <Form.Item
          label="อำเภอปลายทาง"
          className="form-transport"
          name="district_end_id"
          // required
          // rules={[
          //   {
          //     required: true,
          //     message: "กรุณาเลือกอำเภอปลายทาง",
          //   },
          // ]}
        >
          <Select
            placeholder="เลือกอำเภอปลายทาง"
            showSearch
            filterOption={filterOption}
          >
            {masterDistrictDataEnd?.map((item) => (
              <Option key={item.id} value={item.id}>
                {item.name_th}
              </Option>
            ))}
          </Select>
        </Form.Item> */}
        {/* <Form.Item label="ออก" className="form-transport" name="timeStart">
          <TimePicker
            style={{ width: "100%" }}
            size="middle"
            format={"HH:mm"}
          />
        </Form.Item> */}
        {/* <Form.Item label="ถึง" className="form-transport" name="timeEnd">
          <TimePicker
            style={{ width: "100%" }}
            size="middle"
            format={"HH:mm"}
          />
        </Form.Item> */}
        {/* <Form.Item label="ประเภทขนส่ง" className="form-transport" name="type">
          <Select
            placeholder="เลือกประเภทขนส่ง"
            showSearch
            filterOption={filterOption}
          >
            {childrenTransportType}
          </Select>
        </Form.Item> */}
        {/* <Form.Item
          label="เลขทะเบียนรถ"
          name="license_plate"
          className="form-transport"
        >
          <Input size="small" placeholder="กรุณากรอกเลขทะเบียนรถ" />
        </Form.Item> */}
        {/* <Form.Item label="หมายเลขรถ" name="car_no" className="form-transport">
          <Input size="small" placeholder="กรุณากรอกหมายเลขรถ" />
        </Form.Item> */}
        {/* <Form.Item label="จุดจอดที่ลูกค้าต้องการ" name="remark">
          <Input.TextArea placeholder="จุดจอดที่ลูกค้าต้องการ"/>
        </Form.Item> */}
      </Form>

      <Modal
        title="เพิ่มจุดส่งสินค้า"
        open={showParking}
        maskClosable={false}
        onCancel={() => {
          onCloseModal();
        }}
        // onOk={() => form.submit()}
        style={{ top: 20 }}
        footer={[
          <Button key="back" onClick={() => onCloseModal()}>
            ยกเลิก
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={() => formModal.submit()}
          >
            บันทึก
          </Button>,
        ]}
      >
        <WrapperAll>
          <Form form={formModal} onFinish={onFinishModal}>
            <DescriptionForm form={formModal} />
          </Form>
        </WrapperAll>
      </Modal>
    </div>
  );
};

export default UpdateTransportLocal;

const WrapperAll = styled.div`
  display: block;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
`;
